import {Routes} from '@src/Constant/routes';
import {RouteComponentProps} from '@reach/router';
import React from 'react';
import {KeyRouteMap} from '../types';

// Composants liés au profil utilisateur
const ProfileHome = React.lazy(
  () => import('@src/Navigation/Profile/ProfileHome/ProfileHome'),
);
const ProfileMyProfile = React.lazy(
  () => import('@src/Navigation/Profile/ProfileMyProfile/ProfileMyProfile'),
);
const ProfileSubscription = React.lazy(
  () =>
    import('@src/Navigation/Profile/ProfileSubscription/ProfileSubscription'),
);
const ProfileSetting = React.lazy(
  () => import('@src/Navigation/Profile/ProfileSetting/ProfileSetting'),
);
const ProfileHelpdesk = React.lazy(
  () => import('@src/Navigation/Profile/ProfileHelpdesk/ProfileHelpdesk'),
);
const ProfileZendeskForm = React.lazy(
  () => import('@src/Navigation/Profile/ProfileZendeskForm/ProfileZendeskForm'),
);
const ProfileAchievement = React.lazy(
  () => import('@src/Navigation/Profile/ProfileAchievement/ProfileAchievement'),
);
const ProfileNotification = React.lazy(
  () =>
    import('@src/Navigation/Profile/ProfileNotification/ProfileNotification'),
);
const ProfileOpportunities = React.lazy(
  () =>
    import('@src/Navigation/Profile/ProfileOpportunities/ProfileOpportunities'),
);
const ProfileBookmarksScreen = React.lazy(
  () =>
    import(
      '@src/Navigation/Profile/ProfileBookmarksScreen/ProfileBookmarksScreen'
    ),
);
const SessionManagement = React.lazy(
  () => import('@src/components/SessionManagement'),
);

const emptyRoute = {
  component: React.lazy(() => {
    const EmptyComponent = () => React.createElement('div');
    return Promise.resolve({default: EmptyComponent});
  }),
};

export const profileRoutes: KeyRouteMap = {
  [Routes.PROFILE_HOME]: {component: ProfileHome},
  [Routes.PROFILE_MY_PROFILE]: {component: ProfileMyProfile},
  [Routes.PROFILE_SUBSCRIPTION]: {component: ProfileSubscription},
  [Routes.PROFILE_SETTINGS]: {component: ProfileSetting},
  [Routes.PROFILE_LEGAL_INFORMATION]: emptyRoute,
  [Routes.PROFILE_HELPDESK]: {component: ProfileHelpdesk},
  [Routes.PROFILE_ZENDESK_FORM]: {component: ProfileZendeskForm},
  [Routes.PROFILE_ACHIEVEMENT]: {component: ProfileAchievement},
  [Routes.PROFILE_NOTIFICATION]: {component: ProfileNotification},
  [Routes.PROFILE_OPPORTUNITIES]: {component: ProfileOpportunities},
  [Routes.PROFILE_SESSIONS]: {component: SessionManagement},
  [Routes.BOOKMARKS]: {component: ProfileBookmarksScreen},
};
